import React from 'react';

const BaseLayout = ({ children }) => {
    return (
      <div className="min-h-screen w-full bg-[#FFFFFF]">
        <div className="w-full h-screen max-w-[95%] mx-auto p-2">
          {children}
        </div>
      </div>
    );
  };
  
  export default BaseLayout;